import { locations } from "../endpoints/locations.endpoints";
import $axios from "../http/accessor";

const LocationsService = {
  // Countries
  getAllCountries: (page: number = 1, count: number = 100, search?: string) => {
    const params: any = { page, count };
    if (search) params.search = search;
    return $axios.get(locations.countries.get_all, { params });
  },

  getCountryById: (id: number) => {
    return $axios.get(locations.countries.get_by_id(id));
  },

  createCountry: (data: FormData) => {
    return $axios.post(locations.countries.create, data);
  },

  updateCountry: (id: number, data: FormData) => {
    return $axios.put(locations.countries.update(id), data);
  },

  deleteCountry: (id: number) => {
    return $axios.delete(locations.countries.delete(id));
  },

  // Cities
  getAllCities: (
    countryId: number,
    page: number = 1,
    count: number = 100,
    search?: string,
  ) => {
    const params: any = { page, count };
    if (search) params.search = search;
    return $axios.get(locations.cities.get_all(countryId), { params });
  },

  getCityById: (id: number) => {
    return $axios.get(locations.cities.get_by_id(id));
  },

  createCity: (data: FormData) => {
    return $axios.post(locations.cities.create, data);
  },

  updateCity: (id: number, data: FormData) => {
    return $axios.put(locations.cities.update(id), data);
  },

  deleteCity: (id: number) => {
    return $axios.delete(locations.cities.delete(id));
  },
};

export default LocationsService;
